module.exports = __webpack_public_path__ + "static/img/12.307c9be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/12.jpg
// module id = l08I
// module chunks = 1